<template>
  <div>
    <v-btn
      @click="toggleSpecificCodes()"
      small
      text
      color="primary"
      v-if="!showSpecifics"
    >
      {{ showSpecifics ? "Hide" : "Show" }} specific codes
      <v-icon x-small color="primary">{{
        showSpecifics ? "mdi-chevron-up" : "mdi-chevron-down"
      }}</v-icon></v-btn
    >
    <v-slide-y-transition>
      <v-card
        v-if="sortedItems && showSpecifics"
        class="mb-1"
        outline
        flat
        color="#ffffff85"
      >
        <div class="d-flex flex-column flex-sm-row flex-wrap">
          <div v-for="(section, index) in sections" :key="index">
            <div v-if="sortedItems[section]" class="mr-2 mb-1 flexCol">
              <div
                v-for="(code, index) in sortedItems[section]"
                :key="index"
                class="mx-3 d-flex flex-row mb-1 colGroup"
              >
                <span v-if="sevenChar" class="mr-2">
                  <code-with-7
                    :code="code"
                    :label="labelsForCodes[code]"
                    :sevenChar="sevenChar"
                  ></code-with-7> </span
                ><span v-else class="mr-2">
                  <span class="font-weight-medium mr-2">{{ code }}</span>
                  <span v-html="labelsForCodes[code]"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-slide-y-transition>
    <!-- {{ sevenChar }} -->
    <!-- {{ sortedItems }} -->
  </div>
</template>

<script>
import FormatIcdMixin from "@/assets/js/icd/FormatIcdMixin";

export default {
  name: "IcdWidget",
  components: {
    CodeWith7: () => import("./CodeWith7"),
  },
  mixins: [FormatIcdMixin],
  props: {
    codes: null,
    parentObj: null,
    sevenChar: null,
    expandAll: null,
  },
  data: function () {
    return {
      //   selectedCode: null,
      showSpecifics: true,
      yellowStyle: "background-color:yellow",
      sections: [
        "Right",
        "Left",
        "unspecified",
        "Mild",
        "Moderate",
        "Severe",
        "xxx",
        "with macular edema",
        "without macular edema",
      ],
    };
  },
  methods: {
    toggleSpecificCodes() {
      this.showSpecifics = !this.showSpecifics;
    },

    title(obj) {
      let rtn = "";
      if (obj.name) rtn = obj.name;
      if (obj.shortName) rtn = obj.shortName;
      rtn = this.simplifyLaterality(rtn); // (FormatIcdMixin)
      //   rtn += "<span style='yellowStyle'>" + this.lastDigit(obj) + "";
      return rtn;
    },
  },
  computed: {
    codeKeys: function () {
      if (!this.codes) return null;
      return Object.keys(this.codes);
    },
    labelsForCodes: function () {
      if (!this.codes) return null;
      let labels = {};
      for (const code of this.codeKeys) {
        labels[code] = this.title(this.codes[code]);
      }
      return labels;
    },

    sortedItems: function () {
      if (!this.codes) return null;
      let rtn = {};
      let codes = this.codeKeys;
      for (const code of codes) {
        let added = false;
        let name = this.codes[code].name.toLowerCase();
        for (const section of this.sections) {
          if (name.includes(section.toLowerCase())) {
            if (!rtn[section]) rtn[section] = [];
            rtn[section].push(code);
            added = true;
            break;
          }
        }
        if (!added) {
          if (!rtn["xxx"]) rtn["xxx"] = [];
          rtn["xxx"].push(code);
        }
      }

      return rtn;
    },
  },
  mounted: function () {
    // if (this.codes) this.setInitialSelected();
    // if (this.sevenChar) this.selectedSevenChar = Object.keys(this.sevenChar)[0];
  },
  watch: {
    expandAll(val) {
      this.showSpecifics = val;
    },
  },
};
</script>

<style scoped>
.lastChar {
  background-color: #ffcd76;
  padding: 0.5px;
}

.nameAndCode {
  border-bottom: 1px dashed gray;
  min-width: 200px;
}
.flexCol {
  margin-right: 5px;
  min-width: 300px;
}
.colGroup {
  background-color: #f1f1f1;
}
</style>
